import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useProduct = (id) => useQuery({ queryKey: ['product', id], queryFn: async () => {
    const callback = await API.get(`/products/${id}`)
    return callback?.data
}})

export default useProduct